import { Divider, Flex, Text, useBreakpointValue } from '@chakra-ui/react';

export function ListSectionHeader({ label }: { label: string }) {
  const fontSize = useBreakpointValue({ base: 'xs', sm: 'sm' });
  return (
    <Flex align='center' w='full' minW={0} my={1}>
      <Divider flex={1} />
      <Text px={2} flexShrink={0} fontSize={fontSize} fontWeight='semibold' whiteSpace='nowrap'>
        {label}
      </Text>
      <Divider flex={1} />
    </Flex>
  );
}
